"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import HeaderSearchModal from "./HeaderSearchModal";
import { useKey } from "react-use";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import type { ApiWave } from "@/generated/models/ApiWave";
interface HeaderSearchButtonProps {
  readonly wave: ApiWave | null;
}
export default function HeaderSearchButton(t0) {
  const $ = _c(23);
  const {
    wave
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const wasOpenRef = useRef(false);
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      let rafId = null;
      if (wasOpenRef.current && !isOpen) {
        rafId = window.requestAnimationFrame(() => {
          buttonRef.current?.focus({
            preventScroll: true
          });
        });
      }
      wasOpenRef.current = isOpen;
      return () => {
        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
        }
      };
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(true);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleOpen = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClose = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      event: "keydown"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  useKey(_temp, handleOpen, t5);
  const iconSizeClasses = isApp ? "tw-h-6 tw-w-6" : "tw-h-5 tw-w-5";
  const t6 = isApp ? "tw-bg-black" : "tw-bg-iron-800 tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-bg-iron-700";
  let t7;
  if ($[6] !== t6) {
    t7 = clsx("tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-text-iron-300 tw-shadow-sm tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-50 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-primary-400", t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== iconSizeClasses) {
    t8 = clsx("tw-flex-shrink-0", iconSizeClasses);
    $[8] = iconSizeClasses;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <MagnifyingGlassIcon className={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t9) {
    t10 = <button ref={buttonRef} type="button" aria-label="Search" title="Search" onClick={handleOpen} className={t7}>{t9}</button>;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== isOpen || $[16] !== wave) {
    t11 = isOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp2}><HeaderSearchModal onClose={handleClose} wave={wave} /></CommonAnimationOpacity>;
    $[15] = isOpen;
    $[16] = wave;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <CommonAnimationWrapper mode="sync" initial={true}>{t11}</CommonAnimationWrapper>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <div className="tailwind-scope tw-self-center">{t10}{t12}</div>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}
function _temp2(e) {
  return e.stopPropagation();
}
function _temp(event) {
  return event.metaKey && event.key === "k";
}